import { RecordViewMode } from '@aipb/gulliver/dynamic-gallery/model';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { faCrop, faGrid, faGrid2, faImage, faText } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/angular-fontawesome';

interface RecordToolbarMode {
  mode: RecordViewMode;
  icon: IconDefinition;
}

@Component({
  selector: 'dg-record-toolbar',
  templateUrl: './record-toolbar.component.html',
  styleUrls: ['./record-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecordToolbarComponent {
  @Input() activeViewMode: RecordViewMode;

  @Output() changeViewMode: EventEmitter<RecordViewMode> = new EventEmitter<RecordViewMode>();

  masonryIcon = faGrid2;
  masonryWithLabelIcon = faText;
  fancyboxIcon = faImage;
  openLayersIcon = faCrop;
  menuIcon = faGrid;

  modes: RecordToolbarMode[] = [
    {
      mode: 'masonry',
      icon: this.masonryIcon
    },
    {
      mode: 'masonry-with-label',
      icon: this.masonryWithLabelIcon
    },
    {
      mode: 'fancybox',
      icon: this.fancyboxIcon
    },
    {
      mode: 'open-layers',
      icon: this.openLayersIcon
    }
  ];
}
